var exports = {
  "container": "xdbfd91f1--083410--container",
  "invisible": "xdbfd91f1--083410--invisible",
  "tab": "xdbfd91f1--083410--tab",
  "active": "xdbfd91f1--083410--active",
};

module.exports = exports;
